import React from 'react';
import './Todo.css';

const header = () => {
  return (
      <header className='header1'>
      <h1 >Todo-List</h1>
      </header>
  )
  
}


export default header

